import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _courseAssets = [];

let CourseAssetStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _courseAssets.filter(function(e) { return e !== undefined; });
    },
    getById: function(id) {
        return _courseAssets.find(function(e) { return e !== undefined && e.id == id; });
    },
    getByCourse: function(courseId) {
        return _courseAssets.filter(function(e) { return e !== undefined && e.courseId == courseId; });
    },
    add: function(entity) {
        if (entity !== undefined && !!entity.id && !!entity.courseId) {
            var index = _courseAssets.findIndex(function(e) { return e !== undefined && e.id == entity.id && e.courseId == entity.courseId; });
            if (0 <= index) {
                _courseAssets[index] = entity;
            } else {
                _courseAssets.push(entity);
            }
        }
    },
    remove: function(entity) {
        if (entity !== undefined && !!entity.id && !!entity.courseId) {
            var index = _courseAssets.findIndex(function(e) { return e !== undefined && e.id == entity.id && e.courseId == entity.courseId; });
            if (0 <= index) {
                if (!!entity.deleted) {
                    delete _courseAssets[index];
                } else {
                    _courseAssets[index].loading = undefined;
                }
            }
        }
    },

});

CourseAssetStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.COURSE_ASSET_LIST:
            action.data.forEach(CourseAssetStore.add);
            CourseAssetStore.emitChange();
            break;

        case ActionTypes.COURSE_ASSET_LIST_ERROR:
            CourseAssetStore.emitChange();
            break;

        case ActionTypes.COURSE_ASSET_INFO:
            CourseAssetStore.add(action.data);
            CourseAssetStore.emitChange();
            break;

        case ActionTypes.COURSE_ASSET_INFO_ERROR:
            CourseAssetStore.emitChange();
            break;

        case ActionTypes.COURSE_ASSET_ADD:
        case ActionTypes.COURSE_ASSET_UPDATE:
            CourseAssetStore.add(action.data);
            CourseAssetStore.emitChange();
            break;

        case ActionTypes.COURSE_ASSET_ADD_ERROR:
        case ActionTypes.COURSE_ASSET_UPDATE_ERROR:
            // trigger error message
            CourseAssetStore.emitChange();
            break;

        case ActionTypes.COURSE_ASSET_DELETE:
            CourseAssetStore.remove(action.data);
            CourseAssetStore.emitChange();
            break;

        case ActionTypes.COURSE_ASSET_DELETE_ERROR:
            CourseAssetStore.emitChange();
            break;

        default:
            break;

    }

});

export default CourseAssetStore;


